import { Menu } from "primereact/menu";
import { classNames } from "primereact/utils";

import styles from "./table-actions-menu.module.scss";
import type { TableActionsMenuViewProps } from "./types-table-actions-menu";

/** Menu ⋮ da tabela: o gatilho e o `Menu` popup do Prime, que recebe os itens como `model`. */
export function TableActionsMenuView({
  trigger,
  menuRef,
  model,
  menuPt,
  panelClassName,
  panelStyle,
  onShow,
  onHide,
  onKeyDownCapture,
  onKeyDown,
  testId,
  className,
  style,
  rest,
}: TableActionsMenuViewProps) {
  return (
    <span
      className={classNames(styles.root, className)}
      style={style}
      data-testid={testId}
      onKeyDownCapture={onKeyDownCapture}
      onKeyDown={onKeyDown}
      {...rest}
    >
      {trigger}
      <Menu
        ref={menuRef}
        popup
        popupAlignment="right"
        model={model}
        pt={menuPt}
        className={classNames(styles.panel, panelClassName)}
        style={panelStyle}
        onShow={onShow}
        onHide={onHide}
      />
    </span>
  );
}
